// @generated
// This file was automatically generated and should not be edited.
// Run `dev generate pipeline-frontend` to regenerate.

/* eslint-disable unused-imports/no-unused-imports */

// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {ColumnTypeValidationFlag} from 'data-frames/util/validateColumnType';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {LeafType} from 'data-types/benchling-type-def/BenchlingTypeDef';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {PipelineStepDataKind, PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {PipelineStepShape} from 'pipelines/StepShapeUtils';

export const UNION_DATASETS_STEP_SHAPES = [
  {
    stepType: PipelineStepType.UNION_DATASETS,
    isDeprecated: false,
    version: 0,
    inputDataShapes: {
      'Primary data frame': {
        systemName: 'Primary data frame',
        displayName: 'Top dataset',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: true
      },
      'Secondary data frames': {
        systemName: 'Secondary data frames',
        displayName: 'Bottom dataset',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: true
      }
    },
    outputDataShapes: {
      'Output dataset': {
        systemName: 'Output dataset',
        displayName: 'Output dataset',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: true
      }
    },
    config: {
      dataFrameName: {
        kind: 'string',
        required: true
      },
      primaryDataSourceColumns: {
        kind: 'array',
        required: true,
        elementSpec: {
          kind: 'columnReference',
          required: true,
          inputDataName: 'Primary data frame',
          allowMissingColumn: false,
          validationOptions: null
        },
        minItems: 1
      },
      secondaryDataSourcesColumns: {
        kind: 'array',
        required: true,
        elementSpec: {
          kind: 'array',
          required: true,
          elementSpec: {
            kind: 'columnReference',
            required: true,
            inputDataName: 'Secondary data frames',
            allowMissingColumn: false,
            validationOptions: null
          },
          minItems: 1
        },
        minItems: 1
      },
      includeDuplicates: {
        kind: 'boolean',
        required: true
      }
    }
  }
] as const satisfies ReadonlyArray<PipelineStepShape>;
